import React from 'react';
import { HelpCircle } from 'lucide-react';
export function BrandSection() {
  const brands = [{
    name: 'USBB',
    logo: 'https://cdn.magicpatterns.com/uploads/7Sq96stgvAUd9QMBUZhX3i/USBB.png'
  }, {
    name: 'RB Tech',
    logo: 'https://cdn.magicpatterns.com/uploads/hS57J5LCGNNNznTuv6EAgW/RB_Tech.png'
  }, {
    name: 'AMCAN',
    logo: 'https://cdn.magicpatterns.com/uploads/upA32KgucV6jERv1U82Dkq/AMCAN.png'
  }, {
    name: 'Tritan',
    logo: 'https://cdn.magicpatterns.com/uploads/6smuQEjnqUscrrjJtgDmav/TRITAN.png'
  }, {
    name: 'Moline',
    logo: 'https://cdn.magicpatterns.com/uploads/cEUi2Th1V7cTWog2QWkEg3/Moline.png'
  }, {
    name: 'Bestorq',
    logo: 'https://cdn.magicpatterns.com/uploads/6Hb4Ax5X79SG3P9SXNscqu/Bestorq.png'
  }, {
    name: 'Amec',
    logo: 'https://cdn.magicpatterns.com/uploads/8C56hmPQxqWrCRKAaeGMkV/AMEC.png'
  }, {
    name: 'Powerdrive',
    logo: 'https://cdn.magicpatterns.com/uploads/qWf79UahET69dMnQwaffcH/Powerdrive.png'
  }];
  return <section className="bg-gray-100 py-12" data-id="element-147">
      <div className="max-w-7xl mx-auto px-4" data-id="element-148">
        <div className="text-center mb-8" data-id="element-149">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-150">
            Authorized Distributor
          </h2>
          <p className="text-gray-600 text-sm" data-id="element-151">
            Premium brands trusted by industry professionals
          </p>
        </div>

        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-200" data-id="element-152">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 md:gap-8 items-center justify-items-center" data-id="element-153">
            {brands.map(brand => <div key={brand.name} className="flex items-center justify-center p-2" data-id="element-154">
                <img src={brand.logo} alt={`${brand.name} logo`} className="max-h-12 md:max-h-14 w-auto object-contain" data-id="element-155" />
              </div>)}
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-156">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-center sm:text-left" data-id="element-157">
              <HelpCircle className="w-7 h-7 text-gray-500 flex-shrink-0" data-id="element-158" />
              <div data-id="element-159">
                <p className="text-gray-900 font-medium" data-id="element-160">
                  Can't find what you're looking for?
                </p>
                <p className="text-gray-600 text-sm" data-id="element-161">
                  Check our{' '}
                  <a href="/ProductCatalogSitemap.html" className="text-blue-700 hover:underline" data-id="element-162">
                    site map with model charts
                  </a>
                  , or contact our knowledgeable staff to assist with your
                  specific requirements.
                </p>
              </div>
              <a href="/contact" className="flex-shrink-0 bg-gray-800 text-white px-5 py-2 rounded font-medium hover:bg-gray-900 transition-colors" data-id="element-163">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}